module.exports = __webpack_public_path__ + "static/media/Cats eyes 03_ENGELSKA-mixdown.21a4c03c.mp3";